import store from "./redux/store";
import { hasAccountFeature, hasOneAndOnlyAccountFeature, hasPermissions, userServiceMaybeDisplayUpdateEmailMessage } from "./site/userService";
import _ from 'lodash';

export const alerts: Array<{ msg: string, type: string }> = store?.getState()?.commonServiceReducers?.fsConfigReducer?.alerts || [];
export let helpPage: string = '';

export const hasWorldAware = (): boolean => {
  return hasAccountFeature('WORLDAWARE_ALERTS');
};

export const goTo = (whereTo: string): void => {
  window.location.href = whereTo;
};

export const canIssueReports = (): boolean => {
  return hasAccountFeature('TRIP_ASSIST_REPORTS');
};

export const canManageIssues = (): boolean => {
  return hasAccountFeature('TRIP_ASSIST');
};

export const canViewTravelerMap = (): boolean => {
  return hasAccountFeature('TRAVELER_MAP');
};

export const setWindowTitle = (where: string): void => {
  window.document.title = where ? `${where} : Trip Center` : 'Trip Center';
};

export const setHelpPage = (page: string): void => {
  helpPage = page ? `/page/${page}` : '';
  store.dispatch({ type: 'setHelpPage', response: helpPage });
};

export const waiverEditOnly = (): boolean => {
  return hasOneAndOnlyAccountFeature('WAIVER_CREATE_EDIT');
};

export const multiTabView = (): boolean => {
  return waiverEditOnly();
};

export const maybeDispalyUpdateEmailMessage = (user: { email: string; id: number }): void => {
  userServiceMaybeDisplayUpdateEmailMessage(user);
};

export const addAlert = (msg: string, type?: string): void => {
  const defaultMsg = 'Sorry! An error has occurred. Please try again.';
  const defaultType = 'danger';
  const newAlert = {
    msg: msg || defaultMsg,
    type: type || defaultType,
  };

  if (_.filter(alerts, { msg: newAlert.msg }).length > 0) {
    // only show 1 alert per msg
    return;
  }
  const updatedAlerts = [...alerts, newAlert];
  store.dispatch({ type: 'alert', response: updatedAlerts });
  window.scrollTo(0, 0);
};

export const removeAlert = (msg: string): void => {
  const updatedAlerts = _.remove(alerts, a => {
    return a.msg === msg;
  });
  store.dispatch({ type: 'alert', response: updatedAlerts });
};

let lastGarbageCollect: Date | null = null;
export const collectGarbage = (): void => {
  const gc = (window as any).CollectGarbage;
  if (gc && typeof gc === 'function') {
    const now = new Date();
    if (lastGarbageCollect && now.getTime() - lastGarbageCollect.getTime() < 30000) {
      console.log('too soon to collect garbage', lastGarbageCollect);
      return;
    }
    lastGarbageCollect = now;
    console.log('collecting garbage', now);
    gc();
  }
};

export const closeAlert = (index: number): void => {
  store.dispatch({ type: 'closeAlert', response: index });
};

export const canUseWaiverReports = (): boolean => {
  return hasAccountFeature('WAIVER_REPORTING');
};

export const canViewWaivers = (): boolean => {
  return (hasAccountFeature('WAIVER_VIEW') || hasAccountFeature('WAIVER_CREATE_EDIT'));
};

export const removeAllAlerts = (): void => {
  store.dispatch({ type: 'alert', response: [] });
}

export const canEditWaivers = (): boolean => {
  return hasAccountFeature('WAIVER_CREATE_EDIT');
};

export const canViewAnyWaiver = (): boolean => {
  return hasAccountFeature('WAIVER_VIEW');
};

export const isWaiverAdmin = (): boolean => {
  return hasPermissions(['waiver-admin']);
};
